module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "anchor_down_banner.45043c46.svg";